// extracted by mini-css-extract-plugin
var _1 = "_3Wx3HJQG";
export { _1 as "icon" }
